import {SpecificCutResultType} from "../../enums/specific-cut-result-type";
import {SpecificCutOffFlag} from "../../enums/specific-cut-off-flag";
import {SpecificCutSign} from "../../enums/specific-cut-sign";

export class SpecificCutOffClinicalRange {
  result: SpecificCutResultType;
  flag: SpecificCutOffFlag;
  reportAs: string;
  cutoff: string;
  internalComment: string;
  resultComparer: number;
  reportComment: string;
  unitOfMeasure: string;
  sign: SpecificCutSign;


  constructor(result: SpecificCutResultType, flag: SpecificCutOffFlag, reportAs: string, cutoff: string, internalComment: string, resultComparer: number, unitOfMeasure: string, sign: SpecificCutSign, reportComment: string) {
    this.result = result;
    this.flag = flag;
    this.reportAs = reportAs;
    this.cutoff = cutoff;
    this.internalComment = internalComment;
    this.reportComment = reportComment;
    this.resultComparer = resultComparer;
    this.unitOfMeasure = unitOfMeasure;
    this.sign = sign;
  }

  public static matches(cr: SpecificCutOffClinicalRange, result: number) {
    switch (cr.sign)
    {
      case SpecificCutSign.LessThan:
        return result < cr.resultComparer;
      case SpecificCutSign.GreaterThan:
        return result > cr.resultComparer;
      case SpecificCutSign.LessThanOrEqual:
        return result <= cr.resultComparer;
      case SpecificCutSign.GreaterThanOrEqual:
        return result >= cr.resultComparer;
      case SpecificCutSign.Equal:
        return result == cr.resultComparer;
      default:
        return undefined;
    }
  }

  public static getSignRank(cr: SpecificCutOffClinicalRange)
  {
    switch (cr.sign)
    {
      case SpecificCutSign.Equal:
        return 0;
      case SpecificCutSign.LessThanOrEqual:
        return 1;
      case SpecificCutSign.GreaterThanOrEqual:
        return 2;
      case SpecificCutSign.LessThan:
        return 3;
      case SpecificCutSign.GreaterThan:
        return 4;
      default:
        return Number.MAX_SAFE_INTEGER;
    }
  }
}
